"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapBlock = mapBlock;
exports.mapBlocks = mapBlocks;
const jsx_runtime_1 = require("react/jsx-runtime");
const CustomText_1 = __importDefault(require("../components/CustomText"));
const mapToAccordionProps_1 = __importDefault(require("./props/mapToAccordionProps"));
const mapToAuthorLineProps_1 = __importDefault(require("./props/mapToAuthorLineProps"));
const mapToAvailabilityZipFormProps_1 = __importDefault(require("./props/mapToAvailabilityZipFormProps"));
const mapToButtonProps_1 = __importDefault(require("./props/mapToButtonProps"));
const mapToCartProps_1 = __importDefault(require("./props/mapToCartProps"));
const mapToChannelLineupProps_1 = __importDefault(require("./props/mapToChannelLineupProps"));
const mapToColumnBlockProps_1 = __importDefault(require("./props/mapToColumnBlockProps"));
const mapToColumnsProps_1 = __importDefault(require("./props/mapToColumnsProps"));
const mapToCountdownTimerProps_1 = __importDefault(require("./props/mapToCountdownTimerProps"));
const mapToCustomTextProps_1 = __importDefault(require("./props/mapToCustomTextProps"));
const mapToDisclaimerProps_1 = __importDefault(require("./props/mapToDisclaimerProps"));
const mapToFormProps_1 = __importDefault(require("./props/mapToFormProps"));
const mapToImageProps_1 = __importDefault(require("./props/mapToImageProps"));
const mapToLinkProps_1 = __importDefault(require("./props/mapToLinkProps"));
const mapToMegaFormProps_1 = __importDefault(require("./props/mapToMegaFormProps"));
const mapToModalProps_1 = __importDefault(require("./props/mapToModalProps"));
const mapToOutOfAreaFormProps_1 = __importDefault(require("./props/mapToOutOfAreaFormProps"));
const mapToPackageCardProps_1 = __importDefault(require("./props/mapToPackageCardProps"));
const mapToPhoneNumberProps_1 = __importDefault(require("./props/mapToPhoneNumberProps"));
const mapToPriceProps_1 = __importDefault(require("./props/mapToPriceProps"));
const mapToPullquoteProps_1 = __importDefault(require("./props/mapToPullquoteProps"));
const mapToSpeedTestProps_1 = __importDefault(require("./props/mapToSpeedTestProps"));
const mapToStateDropdownProps_1 = __importDefault(require("./props/mapToStateDropdownProps"));
const mapToTableProps_1 = __importDefault(require("./props/mapToTableProps"));
const mapToTabsProps_1 = __importDefault(require("./props/mapToTabsProps"));
const mapToVideoProps_1 = __importDefault(require("./props/mapToVideoProps"));
const mapToPrivacyPolicyProps_1 = __importDefault(require("./props/mapToPrivacyPolicyProps"));
const gatsby_theme_leshen_1 = require("@leshen/gatsby-theme-leshen");
const sylex_1 = require("@leshen/gatsby-theme-leshen/sylex");
const BLOCK_MAPPINGS = {
    accordion: {
        Component: gatsby_theme_leshen_1.Accordion,
        formatProps: mapToAccordionProps_1.default,
    },
    authorLineBlock: {
        Component: gatsby_theme_leshen_1.AuthorLine,
        formatProps: mapToAuthorLineProps_1.default,
    },
    availabilityZipForm: {
        Component: gatsby_theme_leshen_1.AvailabilityForm,
        formatProps: mapToAvailabilityZipFormProps_1.default,
    },
    button: {
        Component: gatsby_theme_leshen_1.LinkButton,
        formatProps: mapToButtonProps_1.default,
    },
    cart: {
        Component: gatsby_theme_leshen_1.Cart,
        formatProps: mapToCartProps_1.default,
    },
    channelLineupBlock: {
        Component: gatsby_theme_leshen_1.ChannelLineupWithData,
        formatProps: mapToChannelLineupProps_1.default,
    },
    columns: {
        Component: gatsby_theme_leshen_1.Columns,
        formatProps: mapToColumnsProps_1.default,
    },
    columnBlock: {
        Component: gatsby_theme_leshen_1.Column,
        formatProps: (params) => (0, mapToColumnBlockProps_1.default)({ ...params, sectionKey: params.sectionKey ?? '' }),
    },
    countdownTimer: {
        Component: gatsby_theme_leshen_1.CountdownTimer,
        formatProps: mapToCountdownTimerProps_1.default,
    },
    disclaimer: {
        Component: gatsby_theme_leshen_1.Brandy,
        formatProps: mapToDisclaimerProps_1.default,
    },
    image: {
        Component: gatsby_theme_leshen_1.Image,
        formatProps: mapToImageProps_1.default,
    },
    modal: {
        Component: gatsby_theme_leshen_1.ModalWithState,
        formatProps: mapToModalProps_1.default,
    },
    phoneNumber: {
        Component: gatsby_theme_leshen_1.LeshenPhoneCTA,
        formatProps: mapToPhoneNumberProps_1.default,
    },
    packageCard: {
        Component: gatsby_theme_leshen_1.PackageCard,
        formatProps: mapToPackageCardProps_1.default,
    },
    price: {
        Component: sylex_1.SylexPrice,
        formatProps: mapToPriceProps_1.default,
    },
    pullquoteBlock: {
        Component: gatsby_theme_leshen_1.Pullquote,
        formatProps: mapToPullquoteProps_1.default,
    },
    speedTestBlock: {
        Component: gatsby_theme_leshen_1.SpeedTest,
        formatProps: mapToSpeedTestProps_1.default,
    },
    table: {
        Component: sylex_1.SylexTable,
        formatProps: mapToTableProps_1.default,
    },
    tabs: {
        Component: gatsby_theme_leshen_1.Tabs,
        formatProps: mapToTabsProps_1.default,
    },
    stateDropdownBlock: {
        Component: gatsby_theme_leshen_1.StateDropdown,
        formatProps: mapToStateDropdownProps_1.default,
    },
    megaForm: {
        Component: sylex_1.SylexMegaForm,
        formatProps: mapToMegaFormProps_1.default,
    },
    form: {
        Component: sylex_1.SylexFormWithMapi,
        formatProps: mapToFormProps_1.default,
    },
    outOfAreaForm: {
        Component: gatsby_theme_leshen_1.FormWithMapi,
        formatProps: mapToOutOfAreaFormProps_1.default,
    },
    link: {
        Component: gatsby_theme_leshen_1.Link,
        formatProps: mapToLinkProps_1.default,
    },
    customText: {
        Component: CustomText_1.default,
        formatProps: mapToCustomTextProps_1.default,
    },
    video: {
        Component: gatsby_theme_leshen_1.Video,
        formatProps: mapToVideoProps_1.default,
    },
    privacyPolicyBlock: {
        Component: gatsby_theme_leshen_1.PrivacyPolicy,
        formatProps: mapToPrivacyPolicyProps_1.default,
    }
};
function mapBlock({ block, mappers, inHero = false, setKey = false, spanish = false, packages = {}, forms = {}, sectionKey = '', inline = false }) {
    if (!block || !('blockType' in block)) {
        const stack = new Error().stack;
        console.log('Missing BlockType', stack);
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    const { Component, formatProps } = BLOCK_MAPPINGS?.[block.blockType] || {};
    if (!Component || !formatProps) {
        console.log(`The blockType (${block.blockType}) does not exist in ModuleBlockMap`);
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    /** Needed to handle the case when columns are set to stacked */
    if (block.blockType === 'columns') {
        const column = block?.columnsReference;
        if (!column || typeof column !== 'object') {
            throw new Error('columns block is missing columnsReference');
        }
        let children = [];
        if (column.items?.length) {
            children = mapBlocks({
                inHero,
                blocks: column.items,
                mappers,
                spanish: spanish,
                packages,
                forms,
                sectionKey,
            });
        }
        if (column.stacked) {
            return (0, jsx_runtime_1.jsx)("div", { children: children });
        }
        return ((0, jsx_runtime_1.jsx)(Component, { sectionKey: sectionKey, spanish: spanish, ...formatProps({
                data: column,
                mappers,
                spanish,
                inHero,
                packages,
                forms,
            }), inHero: inHero, children: children }, setKey && block.id));
    }
    return ((0, jsx_runtime_1.jsx)(Component, { inHero: inHero, spanish: spanish, color: "primary", variant: inHero ? 'hero' : '', ...formatProps({
            data: block,
            mappers,
            spanish: spanish ?? false,
            inHero,
            packages,
            forms,
            sectionKey,
            inline
        }) }, setKey && block.id));
}
function mapBlocks(params) {
    return params.blocks.map((block) => mapBlock({
        block,
        setKey: true,
        inHero: params.inHero,
        mappers: params.mappers,
        spanish: params.spanish,
        packages: params.packages,
        forms: params.forms,
        sectionKey: params.sectionKey,
    }));
}
